import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PermissionsTypes } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button } from '@gem/ui-kit';

import { CallMember } from '../Shared/CallMember/CallMember';
import { CallMemberPermission } from '../Shared/CallMemberPermission/CallMemberPermission';
import { useCallMemberPermissionsPopupPresenter } from './CallMemberPermissionsPopup.presenter';
import styles from './CallMemberPermissionsPopup.styles.m.css';
import { ICallMemberPermissionsPopupProps } from './CallMemberPermissionsPopup.types';
import { DeleteMemberPermissions } from './components/DeleteMemberPermissions/DeleteMemberPermissions';

export const CallMemberPermissionsPopup: FC<ICommonPopupsProps<ICallMemberPermissionsPopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useCallMemberPermissionsPopupPresenter(props);

    return (
      <Popup
        isHidden={props.popupInstance.isHidden}
        title={t('call_custom_permissions')}
        isOpened
        onClose={presenter.onClose}
        handlePrevStep={presenter.goBack}
      >
        <div className={styles.wrapper}>
          <CallMember
            call={presenter.ongoingCall}
            className={styles.member}
            userId={props.params!.userId}
          />
          <div className={styles.divider} />
          <div className={styles.title}>{t('call_what_can_participant_do')}</div>
          <CallMemberPermission
            onClose={presenter.onClose}
            popupInstance={props.popupInstance}
            call={props.params!.call}
            callController={props.params!.callController}
            permissionType={PermissionsTypes.SwitchOnCamera}
            memberPermissionsId={props.params!.userId}
          />
          <CallMemberPermission
            onClose={presenter.onClose}
            popupInstance={props.popupInstance}
            call={props.params!.call}
            callController={props.params!.callController}
            permissionType={PermissionsTypes.SwitchOnMic}
            memberPermissionsId={props.params!.userId}
          />
          <CallMemberPermission
            onClose={presenter.onClose}
            popupInstance={props.popupInstance}
            call={props.params!.call}
            callController={props.params!.callController}
            permissionType={PermissionsTypes.ShareScreen}
            memberPermissionsId={props.params!.userId}
          />
        </div>
        {presenter.isNewMemberPermissions ? (
          <Button
            className={styles.addButton}
            onClick={presenter.onAddClick}
            theme="primary"
          >
            {t('add_button')}
          </Button>
        ) : (
          <DeleteMemberPermissions onDeleteButtonClick={presenter.onDeleteButtonClick} />
        )}
      </Popup>
    );
  });
